import { API_CONSTANT_MAP, API_CONSTANT_DELETE, API_CONSTANT_PROCESS_TREEE_LIST_QRY_SAVE } from '@/common/constants';
import { get, del, post } from '@/utils/http';

export const getConstantBOMap = (method) => {
    return get(API_CONSTANT_MAP, {method});
};

export const deleteConstant = (method) => {
    return del(API_CONSTANT_DELETE.replace(':method', method));
};

export const saveProcessTreeListQry = (param) => {
    return post(API_CONSTANT_PROCESS_TREEE_LIST_QRY_SAVE, param);
};



// WEBPACK FOOTER //
// ./src/data-model/system/constant-model.js